import { useContext } from 'react'

import { PrintShopFormContext } from '@lib/print/print-shop-form-context'
import { PrintShopFormStringsContext } from '@lib/print/print-shop-form-strings-context'

import Button from '@components/buttons/button'

interface ShopFormBackButtonProps {
  disabled?: boolean
}

const ShopFormBackButton = ({ disabled }: ShopFormBackButtonProps) => {
  const { setActiveStepIndex } = useContext(PrintShopFormContext)
  const { shopFormStrings } = useContext(PrintShopFormStringsContext)

  return (
    <Button
      variant="secondary"
      color="black"
      size="normal-small"
      icon="ArrowLeft"
      iconAlignment="left"
      disabled={disabled}
      onClick={(event) => {
        event?.preventDefault()

        setActiveStepIndex((currentStepIndex) => currentStepIndex - 1)
      }}
    >
      {shopFormStrings.shopFormBackButton}
    </Button>
  )
}

export default ShopFormBackButton
